import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import useAddSeats from "api/SubscriptionsResource/useAddSeats";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { activePaymentMethods, activeCurrencies } from "utils";

const PayPal = ({ subscriptionId, additionalSeats, totalAmount, onSuccess, currency }) => {
	const { mutateAsync: addSeats, isLoading } = useAddSeats(subscriptionId, onSuccess);

	const handleApprove = async (data, actions) => {
		try {
			const details = await actions.order.capture();

			await addSeats({
				additional_seats: additionalSeats,
				payment_method: activePaymentMethods.paypal.name,
				currency: currency || activeCurrencies.USD.code,
				total_amount: totalAmount,
				reference: details.id,
			});
		} catch (error) {
			console.error("PayPal payment error:", error);
		}
	};

	const createOrder = (data, actions) => {
		return actions.order.create({
			purchase_units: [
				{
					amount: {
						value: totalAmount.toFixed(2),
					},
					description: `Add ${additionalSeats} seat(s) to subscription`,
				},
			],
		});
	};

	if (isLoading) {
		return (
			<div className="flex flex-col items-center justify-center py-12">
				<AiOutlineLoading3Quarters className="animate-spin text-akgreen mb-4" size={48} />
				<p className="text-gray-600">Processing your payment...</p>
			</div>
		);
	}

	return (
		<div className="space-y-4">
			<div className="bg-blue-50 border-l-4 border-blue-500 p-4">
				<p className="text-blue-700 text-sm">
					<strong>Total to pay:</strong> ${totalAmount.toFixed(2)} for {additionalSeats} additional
					seat (s)
				</p>
			</div>

			<PayPalScriptProvider
				options={{
					"client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
					currency: "USD",
				}}
			>
				<PayPalButtons
					createOrder={createOrder}
					onApprove={handleApprove}
					style={{ layout: "vertical" }}
				/>
			</PayPalScriptProvider>
		</div>
	);
};

export default PayPal;
